<template>
  <div
    class="cruise-booking-app"
    :class="{ loading: loading > 0 }"
    :ship-code="data.ship.shipCode ?? ''"
  >
    <div class="app-header" v-if="!data.viewOrder">
      <NavigatorBar :run="run" />
    </div>

    <div class="app-body">
      <div class="container">
        <div class="wrapper" v-if="data.viewOrder">
          <GuestInfo :run="run" />
        </div>
        <div class="wrapper" v-else>
          <component
            v-for="(component, key) in steps"
            :key="key"
            :is="component"
            :run="run"
          />
        </div>
      </div>
    </div>
    <div class="app-footer"></div>
    <ImageGallery :show="galleryShow" :data="gallery" :run="run" />
    <ModalContent
      :class="modalDataClass"
      :html="modalData"
      :buttons="modalButtons"
      @close="modalData = ''"
    />
  </div>
</template>

<script>
import components from "./components";
export default {
  name: "App",
  components: components,
  props: {
    options: Object,
  },
  watch: {
    "data.step"(newValue, oldValue) {
      if (this.data.steps[oldValue] == undefined) {
        this.data.lastStep = "";
      }
      this.data.oldStep = oldValue;
      this.data.lastStep = this.data.steps[oldValue] ?? "";
    },
    "data.numberOfRoom"() {
      this.repairRoom();
    },
    modalData(value) {
      if (!value) {
        this.modalButtons = false;
      }
    },
  },
  created() {
    this.goToStep = undefined;
    if (this.options) {
      const options = { ...this.options };
      options.config = { ...this.data.config, ...(this.options.config ?? {}) };
      options.ship = { ...this.data.ship, ...(this.options.ship ?? {}) };
      if (options.currentStep != undefined) {
        this.goToStep = options.currentStep;
        delete options.currentStep;
      }
      if (!Array.isArray(options.rooms)) {
        delete options.rooms;
      }
      if (!Array.isArray(options.guests)) {
        delete options.guests;
      }
      this.data = { ...this.data, ...options };
    }
  },
  mounted() {
    if (this.goToStep != undefined) {
      setTimeout(() => this.goStep(this.goToStep), 10);
    } else if (this.step == -1) {
      setTimeout(this.next, 10);
    }
    if (!this.data.numberOfRoom) {
      this.data.numberOfRoom = 1;
    }
  },
  // mounted() {
  //   this.data.config = { ...this.data.config, ...(this.config ?? {}) };
  //   this.data.ship = { ...this.data.ship, ...(this.ship ?? {}) };
  //   if (this.step == -1) {
  //     setTimeout(() => this.next(), 10);
  //   }
  //   if (!this.data.numberOfRoom) {
  //     this.data.numberOfRoom = 1;
  //   }
  // },
  methods: {
    repairRoom() {
      const rooms = [];
      const guests = [];
      for (let i = 0; i < this.data.numberOfRoom; i++) {
        if (typeof this.data.rooms[i] == "undefined") {
          rooms.push({
            numberOfAdults: 2,
            numberOfChildren: 0,
            wheelchair: 0,
            senior: 0,
            category: false,
            categoryType: false,
          });
        } else {
          rooms.push(this.data.rooms[i]);
        }
        if (typeof this.data.guests[i] == "undefined") {
          guests.push({
            active: i == 0,
            complete: false,
            guests: [],
          });
        } else {
          guests.push(this.data.guests[i]);
        }
        const roomGuests = [];

        for (let r = 0; r < rooms[i].numberOfAdults; r++) {
          if (typeof guests[i].guests[r] == "undefined") {
            roomGuests.push({
              title: "",
              firstName: "",
              lastName: "",
              birthdayDay: "",
              birthdayMonth: "",
              birthdayYear: "",
              gender: "",
              citizenship: this.data.config.citizenship ?? "",
              clubNo: "",
              phone: "",
              phoneCode: "852",
              phoneNumber: "",
              email: "",
              fcc: 0,
              active: i == 0,
              complete: 0,
              type: "adult",
              no: r + 1,
            });
          } else {
            guests[i].guests[r].type = "adult";
            guests[i].guests[r].no = r + 1;
            roomGuests.push(guests[i].guests[r]);
          }
        }

        for (let r = 0; r < rooms[i].numberOfChildren; r++) {
          if (
            typeof guests[i].guests[r + rooms[i].numberOfAdults] == "undefined"
          ) {
            roomGuests.push({
              title: "",
              firstName: "",
              lastName: "",
              birthdayDay: "",
              birthdayMonth: "",
              birthdayYear: "",
              gender: "",
              citizenship: this.data.config.citizenship ?? "",
              clubNo: "",
              phone: "",
              phoneCode: "852",
              phoneNumber: "",
              email: "",
              fcc: 0,
              active: i == 0,
              complete: 0,
              type: "child",
              no: r + 1,
            });
          } else {
            guests[i].guests[r + rooms[i].numberOfAdults].type = "child";
            guests[i].guests[r + rooms[i].numberOfAdults].no = r + 1;
            roomGuests.push(guests[i].guests[r + rooms[i].numberOfAdults]);
          }
        }
        guests[i].guests = roomGuests;
      }
      this.data.rooms = rooms;
      this.data.guests = guests;
    },
    tran(key, replaces) {
      key = this.insert_(key).toUpperCase();
      let value =
        typeof window["Joomla"] == "undefined"
          ? key
          : window["Joomla"].Text._("COM_CRUISE_" + key);
      value = value == "COM_CRUISE_" + key || value == "" ? key : value;
      if (replaces) {
        for (const k in replaces) {
          value = value.replaceAll("{" + k + "}", replaces[k]);
        }
      }
      return value;
    },
    run() {
      if (!arguments.length) {
        return;
      }
      var args = Array.prototype.slice.call(arguments);
      const method = args.shift();
      if (this[method] && typeof this[method] == "function") {
        return this[method].apply(this, args);
      } else if (this[method] != undefined) {
        return this[method];
      } else if (this.data[method] != undefined) {
        return this.data[method];
      } else {
        console.warn("Method not found: " + method);
      }
    },
    get(key, defaultValue) {
      let obj = this.data;
      let oKey = key;
      if (!key) {
        return;
      }
      const keys = key.split(".");
      key = keys.pop();
      for (const k of keys) {
        if (typeof obj[k] == "undefined") {
          break;
        }
        obj = obj[k];
      }
      return obj[key] ?? this[key] ?? defaultValue ?? oKey;
    },
    set(key, value, push) {
      let obj = this.data;
      if (!key) {
        return;
      }
      const keys = key.split(".");
      key = keys.pop();
      for (const k of keys) {
        if (typeof obj[k] == "undefined") {
          obj[k] = {};
        }
        obj = obj[k];
      }
      if (!push) {
        obj[key] = value;
        return;
      }
      if (typeof obj[key] == "undefined") {
        obj[key] = [value];
        return;
      }
    },
    setRoot(key, value, push) {
      let obj = this;
      if (!key) {
        return;
      }
      const keys = key.split(".");
      key = keys.pop();
      for (const k of keys) {
        if (typeof obj[k] == "undefined") {
          return;
        }
        obj = obj[k];
      }
      if (!push) {
        obj[key] = value;
        return;
      }
      if (typeof obj[key] == "undefined") {
        obj[key] = [value];
        return;
      }
    },
    stepIndex(stepName) {
      return this.data.steps.indexOf(stepName);
    },
    goGroupStep(groupStep) {
      let maxStep = -1;
      for (const step in this.data.groupStep) {
        if (this.data.groupStep[step] == groupStep) {
          maxStep = Math.max(this.steps.indexOf(step), maxStep);
        }
      }
      this.goStep(maxStep);
      // let minStep = this.steps.length - 1;
      // for (const step in this.data.groupStep) {
      //   if (this.data.groupStep[step] == groupStep) {
      //     minStep = Math.min(this.steps.indexOf(step), minStep);
      //   }
      // }
      // this.goStep(minStep);
    },
    goStepByName(stepName){
      return this.goStep(this.stepIndex(stepName));
    },
    async goStep(step, stepDirection) {
      step = parseInt(step);
      if (step == this.step) {
        return;
      }
      if (step > this.step) {
        this.stepDirection = stepDirection ?? "next";
        for (let s = this.step; s < step; s++) {
          if (s == -1) {
            continue;
          }
          const stepName = this.data.steps[s];
          if (
            this.data.validates[stepName] &&
            typeof this.data.validates[stepName] == "function" &&
            !(await this.data.validates[stepName](step))
          ) {
            step = parseInt(s);
            break;
          }
        }
        this.data.step = step;
        return;
      }
      this.stepDirection = stepDirection ?? "prev";

      for (let s = this.step; s > step; s--) {
        const stepName = this.data.steps[s];
        if (
          this.data.prevs[stepName] &&
          typeof this.data.prevs[stepName] == "function"
        ) {
          if (!this.data.prevs[stepName](step)) {
            return;
          }
        }
      }
      this.data.step = step;
    },
    async next() {
      this.stepDirection = "next";
      this.hideMessage();
      // if (!this.validate()) {
      //   return;
      // }
      if (
        this.data.nexts[this.currentStep] &&
        typeof this.data.nexts[this.currentStep] == "function"
      ) {
        if (!(await this.data.nexts[this.currentStep]())) {
          return;
        }
      }
      if (this.step + 1 >= this.steps.length) {
        return;
      }
      this.data.step++;
      this.scrollToView();
    },
    async prev() {
      this.stepDirection = "prev";
      if (
        this.data.prevs[this.currentStep] &&
        typeof this.data.prevs[this.currentStep] == "function"
      ) {
        if (!(await this.data.prevs[this.currentStep]())) {
          return;
        }
      }
      if (this.data.step - 1 < 0) {
        return;
      }
      this.data.step--;
      this.scrollToView();
    },
    async scrollToView() {
      const box = document.querySelector(".app-nav-middle");
      if (!box) {
        await this.delay(100);
        this.scrollToView();
        return;
      }
      const rect = box.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (isInViewport) {
        return;
      }

      box.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    },
    validate() {
      if (
        this.data.validates[this.currentStep] &&
        typeof this.data.validates[this.currentStep] == "function"
      ) {
        return this.data.validates[this.currentStep]();
      }
      return true;
    },
    fetch: async function (url, data, method) {
      if (!data) {
        method = "GET";
      }
      const params = {
        method: method ?? "POST",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
      };
      if (url.indexOf("http") != 0) {
        url =
          this.data.config.domain.replace(/\/$/, "") +
          "/" +
          url.replace(/^\//, "");
      }
      if (!data) {
        data = {};
      }
      if (this.data.config.token) {
        data[this.data.config.token] = 1;
      }
      data["currentStep"] = this.step;

      if (data && method && method.toLocaleUpperCase() == "GET") {
        url = new URL(url);
        for (const k in data) {
          url.searchParams.append(k, data[k]);
        }
        url = url.toString();
      } else if (data) {
        data.shipCode = this.data.ship.shipCode;
        data.sailDate = this.data.ship.sailDate;
        data.packageId = this.data.ship.packageId;
        data.vaccination = this.data.vaccination;
        data.numberOfDays = this.data.numberOfDays;
        data.departurePortCode = this.data.departurePortCode;
        data.regionCode = this.data.regionCode;
        data.cruiseTitle =  this.data.ship.name;

        if (typeof data.promotionCode == "undefined") {
          data.promotionCode = this.data.promotionCode;
        }
        params.body = JSON.stringify(data);
      }
      const response = await fetch(url, params);
      const res = await response.json();
      if (res && res.subtotal) {
        this.data.subtotal = res.subtotal;
      } else if (res && res.data && res.data.subtotal) {
        this.data.subtotal = res.data.subtotal;
      }
      if (res && res.priceStarting) {
        this.data.priceStarting = res.priceStarting;
      } else if (res && res.data && res.data.priceStarting) {
        this.data.priceStarting = res.data.priceStarting;
      }
      return res;
    },
    insert_(string) {
      string = string.replace(/([a-z])([A-Z])/g, "$1_$2");
      string = string.replace(/([A-Z])([A-Z][a-z])/g, "$1_$2");
      return string;
    },
    showGallery(gallery) {
      this.galleryShow = true;
      this.gallery = gallery;
    },
    modal(html, modalClass) {
      this.modalData = html ?? "";
      this.modalDataClass = modalClass ?? "";
    },
    delay(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(1);
        }, time ?? 100);
      });
    },
    hideMessage() {
      const el = document.getElementById("system-message-container");
      if (el) el.innerHTML = "";
    },
    showMessage(message, type, exitBooking, buttonLabel) {
      if (typeof exitBooking == "undefined") {
        exitBooking = true;
      }
      if ((type == "error" && exitBooking) || buttonLabel != undefined) {
        this.popupAlert(message, [
          {
            label: buttonLabel ?? this.tran("CONFIRM"),
            class: "btn-success",
            action: () => {
              if (exitBooking) {
                const el = document.querySelector("[exit-booking-url]");
                if (el) {
                  this.fetch(el.getAttribute("exit-booking-url"));
                }
                document.location.href = this.data.config.domain;
              }
            },
          },
          // {
          //   label: this.tran("CANCEL"),
          //   class: "btn-warning",
          //   action: () => (this.modalData = ""),
          // },
        ]);
        return;
      }
      if (window["Joomla"] == undefined) {
        return alert(message);
      }
      const messages = {};
      if (typeof type == "undefined") {
        type = "success";
      }
      messages[type] = Array.isArray(message) ? message : [message];
      window["Joomla"].renderMessages(messages);
    },
    popupConfirm(message, action) {
      this.modalData = message;
      this.modalDataClass = "modal-confirm";
      this.modalButtons = [
        {
          label: this.tran("CONFIRM"),
          class: "btn-success",
          action: action,
        },
        {
          label: this.tran("CANCEL"),
          class: "btn-warning",
          action: () => (this.modalData = ""),
        },
      ];
    },
    popupAlert(message, buttons) {
      this.modalData = message;
      this.modalDataClass = "modal-confirm";
      this.modalButtons = buttons;
    },
    submit(action, data, method) {
      this.loading++;
      const form = document.createElement("form");
      form.method = method ?? "POST";
      form.action = action;
      form.style.display = "none";

      data.shipCode = this.data.ship.shipCode;
      data.sailDate = this.data.ship.sailDate;
      data.packageId = this.data.ship.packageId;
      data.vaccination = this.data.vaccination;
      data.numberOfDays = this.data.numberOfDays;
      data.departurePortCode = this.data.departurePortCode;
      data.regionCode = this.data.regionCode;
      data.cruiseTitle =  this.data.ship.name;
      if (typeof data.promotionCode == "undefined") {
        data.promotionCode = this.data.promotionCode;
      }

      for (const key in data) {
        const el = document.createElement("input");
        el.type = "hidden";
        el.name = key;
        el.value = data[key];
        form.appendChild(el);
      }
      document.body.appendChild(form);
      form.submit();
    },
    showLoading() {
      this.loading++;
    },
    hideLoading() {
      this.loading--;
    },
    async scrollToError() {
      await this.delay(200);
      const el = document.querySelector(".error");
      if (!el) {
        return;
      }
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    },
  },
  computed: {
    product() {
      return this.data.product;
    },

    dates() {
      return this.data.dates;
    },
    steps() {
      return this.data.steps;
    },
    step() {
      return this.data.step;
    },
    currentStep() {
      if (this.data.steps[this.data.step] == undefined) {
        return "";
      }
      return this.data.steps[this.data.step];
    },
    customerInfo() {
      return this.data.customerInfo;
    },
    currentGroupStep() {
      return this.data.groupStep[this.currentStep] ?? "";
    },
    totalGuest() {
      let total = 0;
      for (const room of this.data.rooms) {
        total += room.numberOfAdults + room.numberOfChildren;
      }
      return total;
    },
  },
  data() {
    return {
      data: {
        vaccination: "",
        backUrl: false,
        viewOrder: false,
        orderId: "",
        orderCode: "",
        numberOfRoom: 0,
        guests: [],
        rooms: [],
        // roomCategory: "",
        // roomCategoryType: "",
        room: false,
        roomIndex: 0, //-all: all, 0: room 1, 1: room 2,...:
        roomCategories: {},
        currentUserRoomIndex: 0,
        promotionCode: "",
        stepDirection: null,
        subtotal: "",

        steps: [
          "RoomQuantity",
          "RoomGuestQuantity",
          "RoomCategory",
          "RoomChoose",
          "CustomizeOffer",
          "CustomizePreference",
          "ReviewRoom",
          "GuestInfo",
          "ConfirmPayment",
        ],
        groupStep: {},
        oldStep: -1,
        step: -1,
        lastStep: "",
        currency: "$",
        validates: {},
        nexts: {},
        prevs: {},
        ship: {
          name: "cruise name",
          desc: "description",
          fromDate: "<span>TUE</span><span>NOV 28</span><span>2023</span>",
          toDate: "<span>SUM</span><span>DEC 10</span><span>2023</span>",
          banner: "",
          logo: "",
          // roomWarning:'Taxes, fees and port expenses of $132.76 USD per person are additional. "Ad blockers may change the offer. For the axact offer, see Offer Details."'
          roomWarning: "",
          packageId: "",
          sailDate: "",
          shipCode: "",
        },
        config: {
          domain: "",
          paymentUrl: "",
          maxRoom: 3,
          minRoom: 1,
          minAdults: 1,
          maxAdults: 4,
          minChildren: 0,
          maxChildren: 3,
          minGuest: 1,
          maxGuest: 4,
          isDev: false,
          task: "booking",
        },
      },
      galleryShow: false,
      gallery: {},
      modalData: "",
      modalDataClass: "",
      modalButtons: [],
      loading: 0,
    };
  },
};
</script>
<style lang="scss" >
@import "../../../../../../templates/flex/css/font-awesome.min.css";
@import "../../../../../../templates/flex/css/bootstrap.min.css";
@import "../../../../../../templates/flex/css/template.css";
@import "../../../../../../templates/flex/css/custom.css";
</style>    
<!-- <style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px auto 0;
  font-size: 14px;
  max-width: 1000px;
  // .cruise-payment-app {
  //   display: flex;
  //   .left {
  //     width: 70%;
  //   }
  //   .right {
  //     width: 30%;
  //   }
  // }
  // fieldset {
  //   padding: 0 15px;
  //   margin: 0;
  // }
  // *:not(.vue-select) {
  //   -webkit-box-sizing: border-box;
  //   -moz-box-sizing: border-box;
  //   box-sizing: border-box;
  // }
  // .form-group > * {
  //   width: 100%;
  //   text-align: left;
  // }

  // input[type="text"] {
  //   border: 1px solid #b0b2b5;
  //   width: 100%;
  //   padding: 5px 7px;
  //   height: 32px;
  //   border-radius: 4px;
  // }
  // select {
  //   padding: 7px 7px 0;
  //   height: 32px;
  //   width: 100%;
  //   border: 1px solid #b0b2b5;
  //   color: #231f20;
  // }
  // .vue-select input {
  //   border: none;
  //   height: 24px;
  // }

  // label {
  //   margin: 5px 0;
  //   display: block;
  // }
  // .row {
  //   width: 100%;
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
  //   align-items: flex-start;
  //   margin: 0 -15px;
  //   *[class^="col-"] {
  //     display: flex;
  //     flex-direction: column;
  //     margin-bottom: 7px;
  //     align-items: flex-start;
  //     justify-content: flex-start;
  //     flex-wrap: wrap;
  //     padding: 0 15px;
  //   }

  //   .col-sm-2 {
  //     width: 16.66666667%;
  //     flex: 0 0 16.66666667%;
  //   }
  //   .col-sm-3 {
  //     width: 25%;
  //     flex: 0 0 25%;
  //   }

  //   .col-sm-6 {
  //     width: 50%;
  //     flex: 0 0 50%;
  //   }
  //   .col-sm-9 {
  //     width: 75%;
  //     flex: 0 0 75%;
  //   }
  //   .col-sm-10 {
  //     width: 83.33333333%;
  //     flex: 0 0 83.33333333%;
  //   }
  //   .col-sm-12 {
  //     width: 100%;
  //     flex: 0 0 100%;
  //   }
  //   .checkbox {
  //     display: flex;
  //     flex-direction: row;
  //     align-content: center;
  //   }
  // }
  // .v-select:not(.vs--open) input.vs__search {
  //   position: absolute;
  // }
  // .vs__actions svg {
  //   scale: 0.7;
  // }
}
</style> -->
